export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./list.vue?vue&type=template&id=070f353f"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/jackpots/list.vue?vue&type=template&id=070f353f
// module id = SwdR
// module chunks = 0